import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectiveProcessRoutingModule } from './selective-process-routing.module';
import { SelectiveProcessPageComponent } from './pages/selective-process-page/selective-process-page.component';
import { DirectiveModule } from '@shared/directives.module';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { MaterialModule } from '@shared/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    SelectiveProcessPageComponent],
  imports: [
    CommonModule,
    SelectiveProcessRoutingModule,
    FlexModule,
    FlexLayoutModule,
    DirectiveModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class SelectiveProcessModule { }
